<template>
  <div class="q-overlay" v-show="loading">
  </div>
</template>

<script lang="ts" setup>
import {defineProps} from "vue";

defineProps(['loading'])
</script>

<style scoped>
.q-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.35);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
